<template>
  <div>
    <el-select
      :value="selected"
      @input="dispatch"
      :placeholder="placeholder || $t('message.staff')"
      filterable
      clearable
      :multiple="multiple"
      :size="size"
      class="d-block"
      :class="mode ? 'input__day' : 'input__night'"
    >
      <el-option
        v-for="(staff, index) in items"
        :key="'staffs-' + index"
        :label="staff.name + ' ' + staff.last_name"
        :value="staff.id"
      ></el-option>
    </el-select>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { i18n } from "@/utils/i18n";
export default {
  name: "select-staff-by-department",
  props: {
    size: {
      default: "small",
    },
    placeholder: {
      default: null,
    },
    id: {
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Object,
      required: false,
    },
    department_id: {
      type: Number,
      default: null,
      required: false,
    },
  },
  watch: {
    id: {
      handler: function () {
        setTimeout(() => {
          this.selected = this.id;
        });
      },
      deep: true,
      immediate: true,
    },
    department_id: {
      handler: function (newVal, oldVal) {
        if (newVal != oldVal) {
          this.selected = null;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  mounted() {
    if (this.staffs && this.staffs.length === 0) this.fetchStaffs();
  },
  computed: {
    ...mapGetters({
      staffs: "staff/inventory",
      mode:'MODE'
    }),
    items: function () {
      return !this.department_id
        ? this.staffs
        : _.filter(this.staffs, ["department_id", this.department_id]);
    },
  },
  methods: {
    ...mapActions({
      updateInventory: "staff/inventory",
    }),
    dispatch(e) {
      this.$emit("input", e);
      this.selected = e;
    },
    fetchStaffs() {
      const query = { ...this.filter };
      this.updateInventory(query)
        .then((res) => {
          this.loadingData = false;
        })
        .catch((err) => {
          this.loadingData = false;
        });
    },
  },
};
</script>
